import loggedInUserReducer from './LoggedInUserReducer';
import dirtyDataReducer from './DirtyDataReducer';
import FilteringReducer from './FilteringReducer';
import HierarchyReducer from './HierarchyReducer';
import RoutingReducer from './RoutingReducer';
import SiteReducer from './SiteReducer'
import LicenceCheckingReducer from './LicenceCheckingReducer';
import TyreCheckReducer from './TyreCheckReducer';
import earnedRecognitionReducer from './EarnedRecognitionReducer';
import ThemeReducer from './ThemeReducer';
import RulesEngineReducer from './RulesEngineReducer';
import PsvReducer from './PsvReducer';
import { combineReducers } from 'redux';
import EmployeeAssessmentsReducer from 'state/reducers/EmployeeAssessmentsReducer';
import EmployeeReviewsReducer from 'state/reducers/EmployeeReviewsReducer';

export const allReducers = combineReducers({
    loggedInUser: loggedInUserReducer,
    route: RoutingReducer,
    dirtyData: dirtyDataReducer,
    filters: FilteringReducer,
    hierarchy: HierarchyReducer,
    site: SiteReducer,
    licenceChecking: LicenceCheckingReducer,
    employeeAssessments: EmployeeAssessmentsReducer,
    employeeReviews: EmployeeReviewsReducer,
    tyreCheck: TyreCheckReducer,
    earnedRecognition: earnedRecognitionReducer,
    theme: ThemeReducer,
    rulesEngine: RulesEngineReducer,
    psv: PsvReducer
});